<template>
  <div>
    <router-view v-slot="{ Component }">
        <keep-alive>
          <div>
            <Button v-if="route.name !== 'manage-forms'" icon="pi pi-arrow-left" severity="primary" @click="goBack" size="small" class="tw:text-xs tw:mb-2" variant="outlined" rounded />
            <component :is="Component" />
          </div>
        </keep-alive>
    </router-view>
</div>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router';
import Button from 'primevue/button';

const route = useRoute();

const router = useRouter();

function goBack() {
    if (window.history.state.back) {
        router.go(-1);
    } else {
        router.push({name: 'manage-forms' });
    }
}

</script>